"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TriggerClass = /** @class */ (function () {
    function TriggerClass() {
        this.isDeprecated = false;
        this.hasRendered = false;
    }
    TriggerClass.prototype.setIsDeprecated = function (value) {
        this.isDeprecated = value;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TriggerClass.prototype.init = function (actionCallback) {
        return;
    };
    TriggerClass.prototype.toString = function () {
        return 'Unknown trigger called';
    };
    return TriggerClass;
}());
exports.default = TriggerClass;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJpZ2dlckNsYXNzLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvc2VydmljZXMvdHJpZ2dlcnMvVHJpZ2dlckNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUE7SUFBQTtRQUNJLGlCQUFZLEdBQUcsS0FBSyxDQUFBO1FBQ3BCLGdCQUFXLEdBQUcsS0FBSyxDQUFBO0lBY3ZCLENBQUM7SUFaRyxzQ0FBZSxHQUFmLFVBQWdCLEtBQWM7UUFDMUIsSUFBSSxDQUFDLFlBQVksR0FBRyxLQUFLLENBQUE7SUFDN0IsQ0FBQztJQUVELDZEQUE2RDtJQUM3RCwyQkFBSSxHQUFKLFVBQUssY0FBNkI7UUFDOUIsT0FBTTtJQUNWLENBQUM7SUFFRCwrQkFBUSxHQUFSO1FBQ0ksT0FBTyx3QkFBd0IsQ0FBQTtJQUNuQyxDQUFDO0lBQ0wsbUJBQUM7QUFBRCxDQUFDLEFBaEJELElBZ0JDIn0=